import { AxiosError } from 'axios';
import i18n from '@/i18n';
import { edit } from '@/utils';
import { IUpdateAdminProfile } from './types';

async function patchAdminProfile(
	updatedAdmin: IUpdateAdminProfile
): Promise<string | number> {
	try {
		const res = await edit('api/profile', { ...updatedAdmin });
		return res?.status && res.status >= 200 && res.status < 300 ? 200 : 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || i18n.t('profile.errorUpdateProfile'));
	}
}

export { patchAdminProfile };
